import { useEffect, useState } from 'react'
import { Container, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import copiedIcon from '../../../imgs/check-mark.png'
import copyIcon from '../../../imgs/copy-icon.png'
import arrowDownIcon from '../../../imgs/down-arrow.png'
import iconEmail from '../../../imgs/email1.png'
import greeceFlag from '../../../imgs/flags/greece.png'
import greeceFlagCircle from '../../../imgs/flags/greece-circle.png'
import ukFlag from '../../../imgs/flags/uk.png'
import ukFlagCircle from '../../../imgs/flags/uk-circle.png'
import usaFlag from '../../../imgs/flags/usa.png'
import usaFlagCircle from '../../../imgs/flags/usa-circle.png'
// Icons
import iconHome from '../../../imgs/home.png'
import iconMail from '../../../imgs/mailbox.png'
import iconPhone from '../../../imgs/phone.png'
import iconPin from '../../../imgs/pin.png'
import iconUser from '../../../imgs/user.png'
import iconWarehouse from '../../../imgs/warehouse.png'
import warningIcon from '../../../imgs/warning.png'
import { setPackageForPayment } from '../../../store/packageSlice'

export default function PersonalInfoComponent() {
  const { loggedUser } = useSelector(state => state.user)
  const dispatch = useDispatch()

  const [personalInfoState, updatePersonalInfoState] = useState({})
  const [country, setCountry] = useState('USA')

  useEffect(() => {
    updatePersonalInfoState({
      'custom:adress': loggedUser.UserAttributes['custom:adress'],
      'custom:apartment': loggedUser.UserAttributes['custom:apartment'],
      'custom:city': loggedUser.UserAttributes['custom:city'],
      'custom:postalcode': loggedUser.UserAttributes['custom:postalcode'],
      email: loggedUser.UserAttributes.email,
      name: loggedUser.UserAttributes.name,
      family_name: loggedUser.UserAttributes.family_name,
      phone_number: loggedUser.UserAttributes.phone_number,
    })
    const params = window.location.search
    if (params) dispatch(setPackageForPayment(null))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const copyContent = async ev => {
    try {
      await navigator.clipboard.writeText(ev.target.parentElement.parentElement.innerText)
      // console.log('Content copied to clipboard')
      if (ev.target.nextElementSibling) {
        ev.target.style.display = 'none'
        ev.target.nextElementSibling.style.display = 'block'
      }
    } catch (_err) {
      // console.error('Failed to copy: ', err)
    }
  }

  const clickHandler = country => {
    setCountry(country)
  }

  return (
    <section className='personal-info-container'>
      <div>
        <div className='pic-country-navbar'>
          <div className={country == 'USA' ? 'pcn-item pcn-item-active' : 'pcn-item'} onClick={() => clickHandler('USA')}>
            <img src={usaFlag} alt='usa' />
            <div className='pcn-item-title'>ניו ג'רזי</div>
          </div>
          <div className={country == 'USA-tf' ? 'pcn-item pcn-item-active' : 'pcn-item'} onClick={() => clickHandler('USA-tf')}>
            <img src={usaFlag} alt='usa' />
            <div className='pcn-item-title'> דלאוור - TAX FREE</div>
          </div>

          <div className={country == 'GR' ? 'pcn-item pcn-item-active' : 'pcn-item'} onClick={() => clickHandler('GR')}>
            <img src={greeceFlag} alt='greece' />
            <div className='pcn-item-title'>יוון</div>
          </div>

          <div className={country == 'UK' ? 'pcn-item pcn-item-active' : 'pcn-item'} onClick={() => clickHandler('UK')}>
            <img src={ukFlag} alt='uk' />
            <div className='pcn-item-title'>אנגליה</div>
          </div>

          {/* <div className="coming-soon-cont">
            <div className="coming-soon-title">בקרוב</div>
            <div className="coming-soon">
              <div className="pcn-item">
                //<div className={country == 'GR' ? 'pcn-item pcn-item-active' : 'pcn-item'} onClick={() => clickHandler('GR')}>
                <img src={europeFlag} alt="europe" />
                <div className="pcn-item-title">אירופה</div>
                //</div>
              </div>
            </div>
          </div> */}
        </div>

        <div className='pic-warning'>
          <span> חשוב </span>
          למלא את <span> כל הפרטים </span>
          המופיעים בטבלה כשאתם ממלאים את הכתובת!
        </div>

        {country == 'USA' && (
          <>
            <div style={{ height: '0' }}>
              <img src={usaFlagCircle} alt='country' className='pic-table-flag' />
            </div>
            <table className='personal-table'>
              <thead>
                <tr>
                  <th colSpan='2'>הכתובת האמריקאית שלך</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: 'left' }}>
                <tr>
                  <td className='personal-table-td' style={{ borderTop: 'none !important' }}>
                    <img src={iconUser} />
                    Full Name
                  </td>
                  <td className='personal-table-td2' style={{ borderTop: 'none !important' }}>
                    {personalInfoState.name + ' ' + personalInfoState.family_name}
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconPhone} />
                    Phone
                  </td>
                  <td className='personal-table-td2'>
                    732-634-1517
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconPin} />
                    Country
                  </td>
                  <td className='personal-table-td2'>
                    United States
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconHome} />
                    State
                  </td>
                  <td className='personal-table-td2'>
                    New Jersey (NJ)
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconHome} />
                    City
                  </td>
                  <td className='personal-table-td2'>
                    Port Reading
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconMail} />
                    ZIP Code
                  </td>
                  <td className='personal-table-td2'>
                    07064
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconWarehouse} />
                    Address Line 1
                  </td>
                  <td className='personal-table-td2'>
                    <span style={{ marginRight: '25px' }}>600 Markley St</span>
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td colSpan='2' style={{ fontSize: '14px', textAlign: 'center', direction: 'rtl', padding: '1px 20px' }}>
                    <img src={warningIcon} height='24' />
                    <br />
                    <span style={{ fontWeight: 'bold' }}>השלמת הכתובת:</span>
                    <br />
                    כדי להבטיח שהחבילה שלך תגיע אליך במהירות, שורת הזיהוי שלך הכרחית!
                    <br />
                    <img src={arrowDownIcon} height='20' />
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconWarehouse} /> Address Line 2
                  </td>
                  <td className='personal-table-td2'>
                    Shiptanbul {personalInfoState?.phone_number?.split('+9720')[1]}
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        )}

        {country == 'USA-tf' && (
          <>
            <div style={{ height: '0' }}>
              <img src={usaFlagCircle} alt='country' className='pic-table-flag' />
            </div>
            <table className='personal-table'>
              <thead>
                <tr>
                  <th colSpan='2'>הכתובת האמריקאית שלך</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: 'left' }}>
                <tr>
                  <td className='personal-table-td' style={{ borderTop: 'none !important' }}>
                    <img src={iconUser} />
                    Full Name
                  </td>
                  <td className='personal-table-td2' style={{ borderTop: 'none !important' }}>
                    {personalInfoState.name + ' ' + personalInfoState.family_name}
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconPhone} />
                    Phone
                  </td>
                  <td className='personal-table-td2'>
                    732-634-1517
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconPin} />
                    Country
                  </td>
                  <td className='personal-table-td2'>
                    United States
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconHome} />
                    State
                  </td>
                  <td className='personal-table-td2'>
                    Delaware
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconHome} />
                    City
                  </td>
                  <td className='personal-table-td2'>
                    Wilmington
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconMail} />
                    ZIP Code
                  </td>
                  <td className='personal-table-td2'>
                    19808
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconWarehouse} />
                    Address Line 1
                  </td>
                  <td className='personal-table-td2'>
                    3601 Old Capitol Trail
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td colSpan='2' style={{ fontSize: '14px', textAlign: 'center', direction: 'rtl', padding: '1px 20px' }}>
                    <img src={warningIcon} height='24' />
                    <br />
                    <span style={{ fontWeight: 'bold' }}>השלמת הכתובת:</span>
                    <br />
                    כדי להבטיח שהחבילה שלך תגיע אליך במהירות, שורת הזיהוי שלך הכרחית!
                    <br />
                    <img src={arrowDownIcon} height='20' />
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconWarehouse} />
                    Address Line 2
                  </td>
                  <td className='personal-table-td2'>
                    <span style={{ marginRight: '25px' }}>Unit A-7, Shiptanbul {personalInfoState?.phone_number?.split('+9720')[1]}</span>
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className='delaware-info'>
              מומלץ לשלוח את הקניות שלכם לדלאוור אם סכום ההזמנה הכולל עולה על $100.
              <br />
              שימו ❤️ הכתובת בדלאוור אינה מתאימה למשלוח קניות בתחום האופנה, כמו בגדים ונעליים, אשר אינם חייבים במס פנימי בתוך ארה"ב.
              <br />
              משלוח לכתובת זו הינו בתוספת תשלום בהתאם{' '}
              <a href='https://shiptanbul.com/calculator/costs/usa' target='_blank' rel='noopener noreferrer'>
                למחירון שירות משלוח לדלאוור
              </a>
            </div>
          </>
        )}

        {country == 'GR' && (
          <>
            <div style={{ height: '0' }}>
              <img src={greeceFlagCircle} alt='country' className='pic-table-flag' />
            </div>
            <table className='personal-table'>
              <thead>
                <tr>
                  <th colSpan='2'>הכתובת היוונית שלך</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: 'left' }}>
                <tr>
                  <td className='personal-table-td' style={{ borderTop: 'none !important' }}>
                    <img src={iconUser} />
                    Full Name
                    <br />
                    (όνομα + επώνυμο)
                  </td>
                  <td className='personal-table-td2' style={{ borderTop: 'none !important' }}>
                    {personalInfoState.name + ' ' + personalInfoState.family_name}
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconWarehouse} />
                    Address (διεύθυνση)
                  </td>
                  <td className='personal-table-td2'>
                    THESSALONIKIS 4A
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td' style={{ display: 'table-cell' }}>
                    <div className='greece-address-2'>
                      <img src={iconWarehouse} />
                      Address 2 (διεύθυνση)
                      <br />
                      FLAT/APT NUMBER
                    </div>
                  </td>
                  <td className='personal-table-td2' style={{ textAlign: 'center' }}>
                    <span style={{ color: '#ff0000' }}>
                      לא לשכוח להוסיף את שורת הזיהוי שלך בכתובת - כך נדע לשייך אלייך את החבילה <br />
                      <img src={arrowDownIcon} height='20' />
                    </span>
                    <div>
                      <strong>TROY {personalInfoState?.phone_number?.split('+9720')[1]} </strong>
                      <div className='copy-btn' onClick={ev => copyContent(ev)}>
                        <img src={copyIcon} width='18px' className='copy-icon' />
                        <img src={copiedIcon} width='18px' className='copied-icon' />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className='personal-table-td'>
                    <img src={iconPin} />
                    Country (χώρα)
                  </td>
                  <td className='personal-table-td2'>
                    Greece
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className='personal-table-td'>
                    <img src={iconHome} />
                    Province (επαρχία)
                  </td>
                  <td className='personal-table-td2'>
                    ATTIKI
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className='personal-table-td'>
                    <img src={iconHome} />
                    City (πόλη)
                  </td>
                  <td className='personal-table-td2'>
                    NIKAIA-AGIOS <br /> IOANNIS RENTIS
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className='personal-table-td'>
                    <img src={iconMail} />
                    <div>
                      ZIP Code
                      <br />
                      (Ταχυδρομικός Κώδικας)
                    </div>
                  </td>
                  <td className='personal-table-td2'>
                    182 33
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className='personal-table-td'>
                    <img src={iconPhone} />
                    Phone (τηλέφωνο)
                  </td>
                  <td className='personal-table-td2'>
                    +306942695403
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        )}

        {country == 'UK' && (
          <>
            <div style={{ height: '0' }}>
              <img src={ukFlagCircle} alt='country' className='pic-table-flag' />
            </div>
            <table className='personal-table'>
              <thead>
                <tr>
                  <th colSpan='2'>הכתובת האנגלית שלך</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: 'left' }}>
                <tr>
                  <td className='personal-table-td' style={{ borderTop: 'none !important' }}>
                    <img src={iconUser} />
                    Full Name
                  </td>
                  <td className='personal-table-td2' style={{ borderTop: 'none !important' }}>
                    {personalInfoState.name + ' ' + personalInfoState.family_name}
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconPhone} />
                    Phone
                  </td>
                  <td className='personal-table-td2'>
                    (+44) 01753684320
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconPin} />
                    Country
                  </td>
                  <td className='personal-table-td2'>
                    United Kingdom
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconHome} />
                    State
                  </td>
                  <td className='personal-table-td2'>
                    Middlesex
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconHome} />
                    City
                  </td>
                  <td className='personal-table-td2'>
                    Hounslow
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconMail} />
                    Postcode
                  </td>
                  <td className='personal-table-td2'>
                    TW4 6DR
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconWarehouse} />
                    Address Line 1
                  </td>
                  <td className='personal-table-td2'>
                    Unit 5 Maple Grove Business Centre
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td colSpan='2' style={{ fontSize: '14px', textAlign: 'center', direction: 'rtl', padding: '1px 20px' }}>
                    <img src={warningIcon} height='24' />
                    <br />
                    <span style={{ fontWeight: 'bold' }}>השלמת הכתובת:</span>
                    <br />
                    כדי להבטיח שהחבילה שלך תגיע אליך במהירות, שורת הזיהוי שלך הכרחית!
                    <br />
                    <img src={arrowDownIcon} height='20' />
                  </td>
                </tr>

                <tr>
                  <td className='personal-table-td'>
                    <img src={iconWarehouse} />
                    Address Line 2
                  </td>
                  <td className='personal-table-td2'>
                    Shiptanbul {personalInfoState?.phone_number?.split('+9720')[1]}
                    <div className='copy-btn' onClick={ev => copyContent(ev)}>
                      <img src={copyIcon} width='18px' className='copy-icon' />
                      <img src={copiedIcon} width='18px' className='copied-icon' />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        )}
      </div>

      <Container style={{ marginTop: '5%' }} className='rtlText'>
        <Table className='tableForPackagePage'>
          <thead>
            <tr style={{ backgroundColor: '#fcde00', textAlign: 'initial' }}>
              <th
                colSpan='2'
                style={{
                  fontSize: 'large',
                  textAlign: 'center',
                  backgroundColor: '#00aeef',
                  color: 'white',
                  borderBottom: 'none',
                }}
              >
                הפרטים שלי
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td
                style={{
                  fontWeight: 'bolder',
                  textAlign: 'right',
                  marginRight: '1rem',
                  borderTop: 'none',
                }}
                className='personal-table-td1'
              >
                <img src={iconUser} />
                שם מלא
              </td>
              <td style={{ textAlign: 'right', borderTop: 'none' }}>{personalInfoState.name + ' ' + personalInfoState.family_name} </td>
            </tr>
            <tr>
              <td style={{ fontWeight: 'bolder', textAlign: 'right' }} className='personal-table-td1'>
                <img src={iconEmail} />
                אימייל{' '}
              </td>
              <td style={{ textAlign: 'right' }}>{personalInfoState.email} </td>
            </tr>
            <tr>
              <td style={{ fontWeight: 'bolder', textAlign: 'right' }} className='personal-table-td1'>
                <img src={iconHome} />
                כתובת למשלוח
              </td>
              <td style={{ textAlign: 'right' }}>
                {personalInfoState['custom:adress'] +
                  ' ' +
                  personalInfoState['custom:apartment'] +
                  ' , ' +
                  personalInfoState['custom:city'] +
                  ' , ' +
                  personalInfoState['custom:postalcode']}{' '}
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: 'bolder', textAlign: 'right' }} className='personal-table-td1'>
                <img src={iconPhone} />
                טלפון
              </td>
              <td style={{ textAlign: 'right' }}>
                {personalInfoState.phone_number ? personalInfoState.phone_number.split('+972')[1] : ''}
              </td>
            </tr>
          </tbody>
        </Table>
      </Container>
    </section>
  )
}

// const [isEditingPersonalInfo, updateIsEditingPersonalInfo] = useState(false)
// {isEditingPersonalInfo && (
//   <tbody>
//     <tr>
//       <td
//         style={{
//           fontWeight: 'bolder',
//           textAlign: 'right',
//           marginRight: '1rem',
//         }}
//       >
//         שם פרטי
//       </td>
//       <td>
//         <input
//           value={personalInfoState.name}
//           onChange={(e) => {
//             updatePersonalInfoState({
//               ...personalInfoState,
//               name: e.target.value,
//             })
//           }}
//         ></input>
//       </td>
//     </tr>
//     <tr>
//       <td
//         style={{
//           fontWeight: 'bolder',
//           textAlign: 'right',
//           marginRight: '1rem',
//         }}
//       >
//         שם משפחה
//       </td>
//       <td>
//         <input
//           value={personalInfoState.family_name}
//           onChange={(e) => {
//             updatePersonalInfoState({
//               ...personalInfoState,
//               family_name: e.target.value,
//             })
//           }}
//         ></input>
//       </td>
//     </tr>
//     <tr>
//       <td style={{ fontWeight: 'bolder', textAlign: 'right' }}>אימייל</td>
//       <td>
//         <input
//           value={personalInfoState.email}
//           onChange={(e) => {
//             updatePersonalInfoState({
//               ...personalInfoState,
//               email: e.target.value,
//             })
//           }}
//         ></input>
//       </td>
//     </tr>
//     <tr>
//       <td style={{ fontWeight: 'bolder', textAlign: 'right' }}>כתובת (רחוב)</td>
//       <td>
//         <input
//           value={personalInfoState['custom:adress']}
//           onChange={(e) => {
//             updatePersonalInfoState({
//               ...personalInfoState,
//               'custom:adress': e.target.value,
//             })
//           }}
//         ></input>
//       </td>
//     </tr>
//     <tr>
//       <td
//         style={{
//           fontWeight: 'bolder',
//           textAlign: 'right',
//           marginRight: '1rem',
//         }}
//       >
//         מספר דירה / מספר בית
//       </td>
//       <td>
//         <input
//           value={personalInfoState['custom:apartment']}
//           onChange={(e) => {
//             updatePersonalInfoState({
//               ...personalInfoState,
//               'custom:apartment': e.target.value,
//             })
//           }}
//         ></input>
//       </td>
//     </tr>
//     <tr>
//       <td
//         style={{
//           fontWeight: 'bolder',
//           textAlign: 'right',
//           marginRight: '1rem',
//         }}
//       >
//         עיר
//       </td>
//       <td>
//         <input
//           value={personalInfoState['custom:city']}
//           onChange={(e) => {
//             updatePersonalInfoState({
//               ...personalInfoState,
//               'custom:city': e.target.value,
//             })
//           }}
//         ></input>
//       </td>
//     </tr>
//     <tr>
//       <td
//         style={{
//           fontWeight: 'bolder',
//           textAlign: 'right',
//           marginRight: '1rem',
//         }}
//       >
//         מיקוד
//       </td>
//       <td>
//         <input
//           value={personalInfoState['custom:postalcode']}
//           onChange={(e) => {
//             updatePersonalInfoState({
//               ...personalInfoState,
//               'custom:postalcode': e.target.value,
//             })
//           }}
//         ></input>
//       </td>
//     </tr>
//     <tr>
//       <td style={{ fontWeight: 'bolder', textAlign: 'right' }}>טלפון</td>
//       <td>
//         <input
//           value={personalInfoState.phone_number.split('+972')[1]}
//           onChange={(e) => {
//             updatePersonalInfoState({
//               ...personalInfoState,
//               phone_number: '+972' + e.target.value,
//             })
//           }}
//         ></input>
//       </td>
//     </tr>
//   </tbody>
// )}
